import api from '../../../../App/socket';

export const getCapVariants = model_id => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetCapData',
    options: {
        method: 'getVersion',
        params: {
            model_id,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_cap_variants_request.js